import { Serializable } from '@admin/core/models/serializable';
import { BannerStatusEnum } from './banner-status-enum';
import { BannerTargetEnum } from './banner-target-enum';
import { BannerTypeEnum } from './banner-type-enum';

export class BannerModel implements Serializable<BannerModel> {
  fromObject(object: any): BannerModel {
    Object.assign(this, object);

    return this;
  }

  toObject() {
    return {
      BannerId: this.bannerId,
      PositionId: this.positionId,
      StatusId: this.statusId,
      TypeId: this.typeId,
      TargetId: this.targetId,
      Name: this.name,
      ImageFileName: this.imageFileName,
      ImageFileUrl: this.imageFileUrl,
      Link: this.link,
      Code: this.code,
      CreateDate: this.createDate,
      LastChangeDate: this.lastChangeDate,
      lastChangeUserId: this.lastChangeUserId,
      ActivationDate: this.activationDate,
      LastActivationUserId: this.lastActivationUserId,
      DeactivationDate: this.deactivationDate,
      IsOpenNewTab: this.isOpenNewTab,
    };
  }

  public bannerId: number;
  public positionId: number;
  public statusId: BannerStatusEnum;
  public typeId: BannerTypeEnum;
  public targetId: BannerTargetEnum;
  public name: string;
  public imageFileName: string;
  public imageFileUrl: string;
  public link: string;
  public code: string;
  public createDate: Date;
  public lastChangeDate: Date;
  public lastChangeUserId: number;
  public activationDate: Date;
  public lastActivationUserId: number;
  public deactivationDate: Date;
  public isOpenNewTab: boolean;

  constructor() {}
}
